var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"nuiteqModalWrapper"}},[(_vm.open && _vm.boardUrl)?_c('CollaboardModal',{attrs:{"board-url":_vm.boardUrl},on:{"close":_vm.onClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }